<template>
	<v-flex>
		<v-checkbox
				:label="$props.label"
				v-if="!isSimple"
				:readonly="$props.readonly"
				v-model="inputValue"></v-checkbox>
		<v-checkbox
			:label="$props.label"
			v-if="isSimple"
			:readonly="$props.readonly"
			hide-details
			class="ma-0"
			v-model="inputValue"></v-checkbox>
	</v-flex>
</template>

<script>
	export default {
		name: "CheckBox",
		props: ['value', 'label', 'simple', 'readonly'],
		data() {
			return {
				inputValue: this.$props.value
			}
		},
		computed: {
			isSimple() {
				return ((typeof this.$props.simple !== 'undefined') && (this.$props.simple !== false));
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		}
	}
</script>

<style scoped>
</style>
